
import { Route, BrowserRouter, Switch } from 'react-router-dom';
import React from 'react';
import Home from './pages/Home';
import Login from './pages/Login';
//import Register from './pages/Register';
import Register from './pages/RegisterRem';
import Application from './pages/Application';
import Share from './pages/Share';
//import Scheduler from './pages/Scheduler';
import PageNotFound from './pages/PageNotFound';
import Calender from './pages/Calender';

function App() {
  return (
    <React.Fragment>
      <BrowserRouter basename={process.env.PUBLIC_URL} >
        <Switch>
          <Route path="/Register" component={Register} />
          <Route path="/Application" component={Application} />
          <Route path="/Login" component={Login} />
          
          <Route path="/Koledar" component={Calender} />
          <Route path="/Share" render={({ location }) => (
            <Share location={location} />
          )}/>
          
          {
            //replaced the SHARE component above !!
            //<Route path="/share" component={Share} />
          }
          <Route exact path="/" component={Home} />
          <Route component={PageNotFound} />
        </Switch>
      </BrowserRouter>
    </React.Fragment>
  );
}

export default App;
